import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MiroAuthCallbackRequest } from '@shared/index';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { MiroAuthService } from '@shared-angular/services/miro-auth.service';

@Component({
  selector: 'app-miro-auth',
  imports: [],
  template: ''
})
export class MiroComponent {

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private authService = inject(MiroAuthService);
  private toastr = inject(ToastrService);

  constructor() {
    this.route.queryParams.subscribe(async (params) => {
      const parsed = params as Omit<MiroAuthCallbackRequest, "redirect_uri">;
      const { client_id, code, state, team_id, user_id } = parsed;
      if (!client_id || !code || !state || !team_id || !user_id) {
        console.error('Invalid Miro auth callback request', parsed);
        void this.router.navigate(['/']);
        return;
      }
      try {
        await this.authService.authorizeMiro({ ...parsed, redirect_uri: window.location.origin + '/' + window.location.pathname.split("/")[1] + '/auth/miro' });
        window.location.href = window.location.origin + '/' + window.location.pathname.split("/")[1] + "/" + decodeURIComponent(this.fromBase64(state));
      } catch (_error) {
        console.error(_error);
        this.toastr.error("ERROR_403", $localize`:@@failed-to-authenticate:Fehler beim Authentifizieren. Versuche es später erneut.`);
      }
    });
  }

  private fromBase64(b64: string): string {
    const binary = atob(b64);
    const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  }

}
